// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root[dir=rtl] .PopoverSubMenu__rightIcon-f892f3 {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/PopoverMenu/PopoverSubMenu/PopoverSubMenu.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF","sourcesContent":[":root[dir='rtl'] .rightIcon {\n  transform: scaleX(-1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightIcon": `PopoverSubMenu__rightIcon-f892f3`
};
module.exports = ___CSS_LOADER_EXPORT___;
